import errorSkeleton from "../libs/errorSkeleton";
// import {observerRooms, observerUserNotifications, observerUserStatus} from "../libs/socket";
import history from "../libs/history";
import createLink from "../libs/createLink";

export const LOGIN_USER = 'user/LOGIN';
export const LOGIN_USER_SUCCESS = 'user/LOGIN_SUCCESS';
export const LOGIN_USER_FAIL = 'user/LOGIN_FAIL';
export const LOGOUT_USER = 'user/LOGOUT';

const INITIAL_STATE = {
    loading: false,
    authenticated : false,
    error: errorSkeleton
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOGIN_USER:
            return {...state, loading: true, authenticated : false};
        case LOGIN_USER_SUCCESS:
            return {...state, loading: false, error: errorSkeleton, authenticated: true};
        case LOGIN_USER_FAIL:
            return {
                loading: false,
                authenticated : false,
                error: action.error.response
            };
        case LOGOUT_USER:
            return INITIAL_STATE;
        default:
            return state;
    }
};


export function loginUser(data) {
    return {
        type: LOGIN_USER,
        payload: {
            request: {
                method: 'post',
                data,
                url: `/users/login`
            }
        }
    };
}

export const logoutUser = () => {
    history.push(createLink("signin"));
    window.location.reload();
    return dispatch => {
        // deleteAuthenticationToken();
        document.cookie = 'vssmember_id=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'vss_id=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'vss_hash=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'vssmember_id=0;domain=.voissa.com;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'vss_id=;domain=.voissa.com;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'vss_hash=;domain=.voissa.com;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
        localStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`);
        sessionStorage.setItem('disconnected', '1');
        sessionStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`);
        dispatch({type: LOGOUT_USER});
    };
};

// export const deleteAuthenticationToken = ()=>localStorage.removeItem(config.TOKEN_NAME);